import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { Window, WindowHeader, WindowContent, Button, Frame } from "react95";
import { FaTwitter, FaTelegram, FaDiscord, FaCopy } from "react-icons/fa";
import { CopyToClipboard } from "react-copy-to-clipboard";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SharePopup = styled(Window)`
  width: 350px;
  text-align: center;
`;

const ShareButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px 0;
`;

const ShareButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  padding: 10px 15px;

  svg {
    font-size: 18px;
  }
`;

const PreviewCard = styled(Frame)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px;

  img {
    width: 100%;
    max-height: 120px;
    object-fit: cover;
    margin-bottom: 6px;
  }

  h4 {
    margin: 4px 0;
  }

  p {
    font-size: 0.875rem;
    margin: 0;
  }
`;

const SocialSharePopup = ({ competition, onClose, onCopy }) => {
  const competitionUrl = window.location.href;

  // Custom Twitter/X message with better formatting
  const twitterText = encodeURIComponent(
    `${competition.header} Competition on @_blind_faith!\n\n` +
      `Current Jackpot: ${parseFloat(competition.prize_pool).toFixed(
        2
      )} SOL\n` +
      `Ticket Price: ${competition.ticket_price} SOL\n` +
      `Token: $${competition.token_symbol}\n\n` +
      `DO YOU BELIEVE?`
  );

  const encodedUrl = encodeURIComponent(competitionUrl);

  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?text=${twitterText}&url=${encodedUrl}`,
    telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodeURIComponent(
      `${competition.header} Competition on @blindfaithofficial!\n\n` +
        `Current Jackpot: ${parseFloat(competition.prize_pool).toFixed(
          2
        )} SOL\n` +
        `Ticket Price: ${competition.ticket_price} SOL\n` +
        `Token: $${competition.token_symbol}\n\n` +
        `DO YOU BELIEVE?`
    )}`,
    discord: competitionUrl, // Discord doesn't have direct URL sharing, will copy to clipboard
  };

  const openLink = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const previewTitle = `${competition.token_name} Competition - ${parseFloat(
    competition.prize_pool
  ).toFixed(2)} SOL Jackpot`;
  const previewDescription = competition.description || "DO YOU BELIEVE?";
  const previewImage =
    competition.banner_image || competition.token_icon || "/socialmedia.png";

  const handleDiscordShare = () => {
    navigator.clipboard
      .writeText(
        `**${competition.header} Competition**\n\n` +
          `**Jackpot:** ${competition.prize_pool} SOL\n` +
          `**Ticket Price:** ${competition.ticket_price} SOL\n` +
          `**Description:** ${competition.description}\n\n` +
          `Join now: ${competitionUrl}`
      )
      .then(() => {
        onCopy("Discord message copied to clipboard!");
      });
  };

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  return createPortal(
    <Overlay onClick={onClose}>
      <SharePopup onClick={(e) => e.stopPropagation()}>
        <WindowHeader className="window-header-styled">
          <span>Share_Competition.eXe </span>
          <Button
            onClick={onClose}
            style={{ marginLeft: "auto", padding: "0 10px" }}
          >
            X
          </Button>
        </WindowHeader>

        <WindowContent>
          <ShareButtonsContainer>
            <ShareButton onClick={() => openLink(shareLinks.twitter)}>
              <FaTwitter style={{ color: "#1DA1F2" }} />
              Share on X
            </ShareButton>

            <ShareButton onClick={() => openLink(shareLinks.telegram)}>
              <FaTelegram style={{ color: "#0088cc" }} />
              Share on Telegram
            </ShareButton>

            <ShareButton onClick={handleDiscordShare}>
              <FaDiscord style={{ color: "#5865F2" }} />
              Copy Discord Message
            </ShareButton>

            <CopyToClipboard
              text={competitionUrl}
              onCopy={() => onCopy("Competition URL copied to clipboard!")}
            >
              <ShareButton>
                <FaCopy style={{ color: "#666" }} />
                Copy Link
              </ShareButton>
            </CopyToClipboard>
          </ShareButtonsContainer>
        </WindowContent>
      </SharePopup>
    </Overlay>,
    document.body
  );
};

export default SocialSharePopup;
